<template>
    <div>
        <br>
        <nav class="navbar navbar-expand-lg navbar-light">
            <div class="ml-auto">
                <form class="form-inline">
                    <date-picker v-model="search.date"
                                 :lang="lang"
                                 range
                                 :format="changeFormat"
                                 placeholder="วันที่เริ่มต้น - วันที่สิ้นสุด" confirm>
                    </date-picker> &nbsp;
                    <multiselect
                        class="form-control border-0"
                        :options="sellers"
                        v-model="search.sale"
                        label="name"
                        :show-labels="false"
                        placeholder="ค้นหาเซลล์"
                        track-by="id">
                    </multiselect> &nbsp;
                    <multiselect
                        class="form-control border-0"
                        :options="provinces"
                        v-model="search.province"
                        @input="getDistricts(search.province)"
                        label="name"
                        :show-labels="false"
                        placeholder="ค้นหาจังหวัด"
                        track-by="id">
                    </multiselect> &nbsp;
                    <multiselect v-if="search.province"
                                 class="form-control border-0"
                                 :options="districts"
                                 v-model="search.district"
                                 @input="getSubDistricts(search.district)"
                                 label="name"
                                 :show-labels="false"
                                 placeholder="ค้นหาเขต / อำเภอ"
                                 track-by="id">
                    </multiselect> &nbsp;
                    <multiselect v-if="search.district"
                                 class="form-control border-0"
                                 :options="subDistricts"
                                 v-model="search.sub_district"
                                 label="name"
                                 :show-labels="false"
                                 placeholder="ค้นหาแขวง / ตำบล"
                                 track-by="id">
                    </multiselect> &nbsp;
                    <button type="button" class="btn btn-success" @click="searchReportInvoiceSale">
                        <icon name="search"></icon>
                        ค้นหา
                    </button>
                </form>
            </div>
        </nav>
        <div class="col-sm-12 table-responsive">
            <table class="table table-bordered">
                <thead>
                <tr>
                    <th rowspan="2">รยการ TN</th>
                    <th rowspan="2">เซลล์</th>
                    <th rowspan="2">ตำบล</th>
                    <th rowspan="2">อำเภอ</th>
                    <th rowspan="2">จังหวัด</th>
                    <th colspan="6">ยอดขาย</th>
                    <th colspan="6">จำนวนขาย</th>
                </tr>
                <tr>
                    <template v-for="thead in type">
                        <th>{{ thead.text }}</th>
                    </template>
                    <template v-for="thead in type">
                        <th>{{ thead.text }}</th>
                    </template>
                </tr>
                </thead>
                <tbody>
                <template v-for="data in report_invoice_sale">
                    <tr>
                        <td>{{ data.invoice_id }}</td>
                        <td>{{ data.customer && data.customer.sale ? data.customer.sale.name : '-' }}</td>
                        <td>{{ data.customer && data.customer.sub_district ? data.customer.sub_district.name : '-' }}
                        </td>
                        <td>{{ data.customer && data.customer.district ? data.customer.district.name : '-' }}</td>
                        <td>{{ data.customer && data.customer.province ? data.customer.province.name : '-' }}</td>
                        <td>{{ data.foam.product_type_id ? data.foam.quantity : 0 | amount }}</td>
                        <td>{{ data.glass.product_type_id ? data.glass.quantity : 0 | amount }}</td>
                        <td>{{ data.spoon.product_type_id ? data.spoon.quantity : 0 | amount }}</td>
                        <td>{{ data.tube.product_type_id ? data.tube.quantity : 0 | amount }}</td>
                        <td>{{ data.other.product_type_id ? data.other.quantity : 0 | amount }}</td>
                        <td>{{ data.sum_quantity | amount }}</td>

                        <td>{{ data.foam.product_type_id ? data.foam.total_price : 0 | currency }}</td>
                        <td>{{ data.glass.product_type_id ? data.glass.total_price : 0 | currency }}</td>
                        <td>{{ data.spoon.product_type_id ? data.spoon.total_price : 0 | currency }}</td>
                        <td>{{ data.tube.product_type_id ? data.tube.total_price : 0 | currency }}</td>
                        <td>{{ data.other.product_type_id ? data.other.total_price : 0 | currency }}</td>
                        <td>{{ data.sum_total_price | amount }}</td>
                    </tr>
                </template>
                </tbody>
            </table>
            <vue-pagination :pagination="dataPaginate" @paginate="getPage">
            </vue-pagination>
            <b-modal hide-header hide-footer ref="loading">
                <loading :msg="msg" :status="status_loading" @submit="hideLoadingModal">
                </loading>
            </b-modal>
        </div>
        <!--        <pre class="alert-primary">{{report_invoice_sale}}</pre>-->
    </div>
</template>

<script>
import {mapState} from "vuex";
import Multiselect from "vue-multiselect";
import DatePicker from 'vue2-datepicker'
import moment from "moment";
import VuePagination from "../../Pagination";
import Loading from "../../Utility/Loading";

export default {
    name: "dashboard-report-invoice-sale",
    components: {
        Loading,
        VuePagination,
        Multiselect, DatePicker
    },
    created() {
        this.getReportInvoiceSale();
    },
    data() {
        return {
            page: 1,
            msg: '',
            status_loading: '',
            event_submit: false,
            report_invoice_sale: [],
            type: [
                {text: 'โฟม', value: 1},
                {text: 'แก้ว', value: 2},
                {text: 'ช้อน', value: 3},
                {text: 'หลอด', value: 4},
                {text: 'เบ็ดเตล็ด', value: 5},
                {text: 'รวม', value: 6},
            ],
            search: {
                date: [],
                sale: null,
                province: null,
                district: null,
                sub_district: null
            },
            changeFormat: {
                stringify: (date) => {
                    if(date && moment(date).format('MM') == '02' && moment(date).format('DD') == '29')
                          return '29/02/' + moment(date).add(543, 'y').format('YYYY');
                      return date ? moment(date).add(543, 'y').format('DD/MM/YYYY') : null
                },
                parse: (value) => {
                    return value ? moment(value, 'DD/MM/YYYY').subtract(543, 'y').toDate() : null
                }
            },
            lang: {
                days: ['อา', 'จ', 'อ', 'พ', 'พฤ', 'ศ', 'ส'],
                months: ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'],
                pickers: ['ถัดไป 7 วัน', 'ถัดไป 30 วัน', 'ก่อนหน้า 7 วัน', 'ก่อนหน้า 30 วัน'],
                placeholder: {
                    date: 'วว/ดด/ปปปป',
                }
            },
            dataPaginate: {
                current_page: 1,
                from: 1,
                last_page: 1,
                per_page: 1,
                total: 1,
                to: 1
            },
        }
    },
    computed: {
        ...mapState({
            sellers: state => {
                return state.Seller.data;
            },
            provinces: state => {
                return state.Common.province;
            },
            districts: state => {
                return state.Common.districts;
            },
            subDistricts: state => {
                return state.Common.sub_districts;
            },
        }),
    },
    methods: {
        showLoadingModal() {
            this.$refs.loading.show();
        },
        hideLoadingModal() {
            this.$refs.loading.hide();
        },
        getDistricts(province) {
            this.search.district = null;
            this.search.sub_district = null;
            if (province) {
                //console.log(province.code);
                this.$store.dispatch('Common/setDistrict', province.code);
            }
        },
        getSubDistricts(districts) {
            this.search.sub_district = null;
            if (districts) {
                this.$store.dispatch('Common/setSubDistrict', districts.district_id);
            }
        },
        getReportInvoiceSale() {
            let data = {
                sale_id: 34,
                start_date: moment().format("YYYY-MM-DD"),
                end_date: moment().format("YYYY-MM-DD"),
                province_id: "",
                district_id: "",
                sub_district_id: ""
            };
            this.$store.dispatch("Dashboard/getReportInvoiceSale", {
                page: this.page,
                data: data
            }).then(res => {
                this.report_invoice_sale = res.data;
                this.dataPaginate = {
                    current_page: res.current_page,
                    from: res.from,
                    last_page: res.last_page,
                    per_page: res.per_page,
                    total: res.total,
                    to: res.to
                }
                this.hideLoadingModal();
            })
        },
        searchReportInvoiceSale() {
            if (this.search.date > 0 && this.search.date[0]) {
                this.search.date = [];
            }
            if (this.search.date.length < 1) {
                alert("กรึณาเลือกวันที่");
            } else if (!this.search.sale) {
                alert("กรุณาเลือกเซลล์");
            } else {
                this.msg = "กำลังดาวโหลดข้อมูล";
                this.status_loading = 1;
                this.showLoadingModal();
                this.event_submit = true;
                let sale_id = "";
                let start_date = "";
                let end_date = "";
                let province_id = "";
                let district_id = "";
                let sub_district_id = "";
                if (this.search.sale) {
                    sale_id = this.search.sale.id;
                }
                if (this.search.date.length > 0) {
                    if (!this.search.date[0] && !this.search.date[0]) {
                        this.search.date = [];
                    }
                    if (this.search.date.length > 0) {
                        start_date = moment(this.search.date[0]).format("YYYY-MM-DD");
                        end_date = moment(this.search.date[1]).format("YYYY-MM-DD");
                    }
                }
                if (this.search.province) {
                    province_id = this.search.province.id
                }
                if (this.search.district) {
                    district_id = this.search.district.id
                }
                if (this.search.sub_district) {
                    sub_district_id = this.search.sub_district.id
                }
                let data = {
                    sale_id: sale_id,
                    start_date: start_date,
                    end_date: end_date,
                    province_id: province_id,
                    district_id: district_id,
                    sub_district_id: sub_district_id,
                };
                this.$store.dispatch("Dashboard/getReportInvoiceSale", {
                    page: this.page,
                    data: data
                }).then(res => {
                    this.report_invoice_sale = res.data;
                    this.dataPaginate = {
                        current_page: res.current_page,
                        from: res.from,
                        last_page: res.last_page,
                        per_page: res.per_page,
                        total: res.total,
                        to: res.to
                    }
                    this.hideLoadingModal();
                }).catch(() => {
                    this.msg = "ดาวโหลดข้อมูลไม่สำเร็จ";
                    this.status_loading = 3;
                    this.showLoadingModal();
                })
            }
        },
        getPage() {
            this.msg = "กำลังดาวโหลดข้อมูล";
            this.status_loading = 1;
            this.showLoadingModal();
            this.page = this.dataPaginate.current_page;
            if (this.event_submit) {
                this.searchReportInvoiceSale();
            } else {
                this.getReportInvoiceSale();
            }
        },
    }
}
</script>

<style scoped>

</style>
